export default __webpack_public_path__ + "static/media/globe.3f2ca51d.jpg";